export default __webpack_public_path__ + "static/media/logo.9a1ad709.webp";